import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const DEFAULT_SIZE = "md";
const SIZES = {
    xxs: {
        diameter: 12,
        thickness: 3,
    },
    xs: {
        diameter: 15,
        thickness: 3,
    },
    sm: {
        diameter: 30,
        thickness: 4,
    },
    md: {
        diameter: 70,
        thickness: 7,
    },
    lg: {
        diameter: 100,
        thickness: 8,
    },
};
const Container = styled.div `
    color: ${({ theme }) => theme.colors.textDefault};
    display: inline-block;
    text-align: center;
    vertical-align: ${({ inline }) => (inline ? "-1px" : 0)};

    div {
        margin: ${({ inline, inlineRight }) => inlineRight ? "0 0 0 5px" : inline ? "0 5px 0 0" : "15px auto"};
    }
`;
const spinAnimation = keyframes `
    0% {transform: rotate(0deg)}
    100% {transform: rotate(360deg)}
`;
const Spinner = styled.div `
    animation: 0.7s ${spinAnimation} linear infinite;
    border-color: ${({ color, theme }) => color || theme.palette.primary[0]};
    border-width: ${({ size }) => SIZES[size || DEFAULT_SIZE].thickness}px;
    border-style: solid;
    border-top-color: transparent;
    border-radius: 50%;
    height: ${({ size }) => SIZES[size || DEFAULT_SIZE].diameter}px;
    width: ${({ size }) => SIZES[size || DEFAULT_SIZE].diameter}px;
`;
const LoadSpinner = ({ color, inline, inlineRight, message, size, ...rest }) => (jsxs(Container, { inline: inline, inlineRight: inlineRight, ...rest, children: [jsx(Spinner, { color: color, size: size }), message && jsx("small", { children: message })] }));

export { LoadSpinner };
